module.exports = __webpack_public_path__ + "media/use_cases/slide1-8d17f1af.png";